import React from 'react'
import Footer from './../Components/Common/Footer';
import Navbar from './../Components/Common/Navbar';
import Home from './../Pages/Home';
import {  Route, Routes, useLocation, } from 'react-router-dom';
import Questions from './../Pages/Questions';
import { APP_ROUTES } from './AppRoutes';
import PrivacyPolicy from '../Pages/Policies/PrivacyPolicy';
import TermsOfUse from '../Pages/Policies/TermsOfUse';
import Services from '../Pages/Services';
import Contact from '../Pages/Contact';
import RoughQuestions from '../Pages/Questions/RoughQuestions';

const PageRouting = () => {

  const location = useLocation();

  // Determine if Navbar should be hidden
  const hideNavbarRoutes = [APP_ROUTES.GETSTARTED]; // Add paths where Navbar should not appear
  const showNavbar = !hideNavbarRoutes.includes(location.pathname);
  return (
    <div>
       {showNavbar && <Navbar />}
      <div className='min-h-screen '>
      
        <Routes>
        <Route index element={<Home />} />
        <Route path={APP_ROUTES.GETSTARTED} element={<Questions />} />
        <Route path={APP_ROUTES.ROUGHQUESTIONS} element={<RoughQuestions />} />
        <Route path={APP_ROUTES.SERVICES} element={<Services />} />
        <Route path={APP_ROUTES.CONTACT} element={<Contact />} />
        <Route path={APP_ROUTES.PRIVACYPOLICY} element={<PrivacyPolicy />} />
        <Route path={APP_ROUTES.TERMSOFUSE} element={<TermsOfUse />} />
        </Routes>
    
      </div>
      <div className="px-[2%] md:px-[6%] bg-secondary mt-32">
        <div className="pt-20">
          <Footer />
        </div>
      </div>
    </div>
  )
}

export default PageRouting
